import { Routes, Route, Navigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import './Pastor.scss';

import PastorLanding from './pages/PastorLanding';
import PastorProfileEdit from './pages/PastorProfileEdit';
import ChurchRequest from './pages/ChurchRequest';
import PastorJobs from './pages/PastorJobs';
import MyPastorCall from './pages/MyPastorCall';
import DeliveredView from './pages/DeliveredView';
import ConsultFloating from './components/ConsultFloating';

// 담임목사청빙지원 — 사역자모아가 담임목회 희망 이력서와 교회의 청빙 의뢰를 잇는다 (pastor-call-design.md)
export default function PastorRouter() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<PastorLanding />} />
        {/* 사역자: 담임목회 희망 이력서 맡기기 */}
        <Route path="/profile" element={<PastorProfileEdit />} />
        {/* 담임 공고 + 청빙 의뢰 소식 */}
        <Route path="/jobs" element={<PastorJobs />} />
        {/* 교회: 청빙 의뢰서 (로그인 없이도) */}
        <Route path="/request" element={<ChurchRequest />} />
        {/* 사역자: 추천·청빙 소식 / 교회: 의뢰 현황 */}
        <Route path="/my" element={<MyPastorCall />} />
        {/* 교회가 전달받은 후보 이력서 (이메일 링크) */}
        <Route path="/delivered/:token" element={<DeliveredView />} />
        {/* 예전 주소 */}
        <Route path="/talent" element={<Navigate to="/pastor/request" replace />} />
        <Route path="/church" element={<Navigate to="/pastor/request" replace />} />
        <Route path="/proposals" element={<Navigate to="/pastor/my" replace />} />
        <Route path="*" element={<Navigate to="/pastor" replace />} />
      </Routes>
      <ConsultFloating />
      <ScrollToTopButton />
      <Footer />
    </div>
  );
}
